var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"}));
}

Maximize.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-maximize"};

module.exports = Maximize;

Maximize.default = Maximize;
